import React, { useState, useEffect } from "react";
import SubHead from "./SubHead";
import { GetList } from "./http";
import ScrollOut from "scroll-out";
import { Viewer } from "@toast-ui/react-editor";
import "@toast-ui/editor/dist/toastui-editor-viewer.css";

const Result = () => {
    const [items, setItems] = useState([]);
    const [data, setData] = useState({
        page: 1,
        size: 100,
        sort: "-id"
    });

    useEffect(() => {
        GetList(data, res => {
            setItems(res.rows);
        });

        ScrollOut({
            threshold: 0.1,
            once: true
        });
    }, []);

    useEffect(() => {
        setHoverWraps();
    }, [items]);

    const setHoverWraps = () => {
        const hoverElem = document.querySelectorAll(".hoverWraps");
        hoverElem.forEach(elem => {
            elem.addEventListener("mouseenter", e => {
                e.currentTarget.childNodes[0].classList.add("on");
            });
            elem.addEventListener("mouseleave", e => {
                e.currentTarget.childNodes[0].classList.remove("on");
            });
        });
    };

    return (
        <>
            <SubHead title="사업실적" eng="RESULT"></SubHead>
            <main className="sub-contents">
                <div className="inner">
                    {/* <table className="tbl_normal black wAuto" data-scroll>
                        <colgroup>
                            <col width="auto" />
                            <col width="20%" />
                            <col width="20%" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>사업명</th>
                                <th>수행기간</th>
                                <th>발주처</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map(x => (
                                <tr>
                                    <td className="textL">{x.title}</td>
                                    <td>{x.date}</td>
                                    <td>{x.order}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <p style={{ margin: "30px 0 10px", fontSize: "20px" }}>예제</p> */}
                    <table className="tbl_normal black wAuto" data-scroll>
                        <colgroup>
                            <col width="auto" />
                            <col width="20%" />
                            <col width="20%" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>사업명</th>
                                <th>수행기간</th>
                                <th>발주처</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map(x => {
                                const contents = x.content.split("\n").filter(content => content.trim().length > 0);
                                return (
                                    <tr>
                                        <td className="textL">
                                            <div className="hoverWraps">
                                                <p className="hoverText">{x.title}</p>
                                                <div className="hoverNextContents">
                                                    <div className="inner">
                                                        {contents.map(content => (
                                                            <p>- {content.trim()}</p>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>{x.date}</td>
                                        <td>
                                            {/* <p dangerouslySetInnerHTML={{ __html: x.order }}></p> */}
                                            <Viewer initialValue={x.order || ""} />;
                                        </td>
                                    </tr>
                                );
                            })}
                            {/* <tr>
                                <td className="textL">
                                    <div className="hoverWraps">
                                        <p className="hoverText">5G융합서비스 공공부문 선도적용 _분당S병원</p>
                                        <div className="hoverNextContents">
                                            <div className="inner">
                                                <p>- 공공의료영역의 비대면서비스 확산 및 디지털전환의 가속화를 위한 5G 특화망 기반의 융합서비스 모델 발굴, 선도적용</p>
                                                <p>- 자동주행 전동휠체어 서비스, 진료재료/약품/린넨 무인이송 서비스, 스마트 시뮬레이션센터 구축을 통한 공공의료 융합서비스 제공</p>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td>2022년 ~ 2027년</td>
                                <td>NIA(한국지능정보사회진흥원) ※5G특화망 국책과제</td>
                            </tr>
                            <tr>
                                <td className="textL">
                                    <div className="hoverWraps">
                                        <p className="hoverText">28GHz 5G 특화망 기반 시공간을 뛰어넘는 경험적 혁신을 위한 의료 교육 플랫폼 개발 및 실증_SS서울병원</p>
                                        <div className="hoverNextContents">
                                            <div className="inner">
                                                <p>- 병원 내 28GHz 5G 특화망 인프라 구축 및 실감형 교육 서비스 제공을 통하여 5G 기반 (삭제) 의료교육 생태계 조성</p>
                                                <p>- 28GHz 5G 특화망 통신망 기반의 AR글라스, 360도 카메라 등의 교육서비스 디바이스 활용으로 첨단 의료교육 서비스 제공</p>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td>2022년 ~ 2025년</td>
                                <td>nipa(정보통신산업진흥원) ※5G특화망 국책과제</td>
                            </tr>
                            <tr>
                                <td className="textL">
                                    <div className="hoverWraps">
                                        <p className="hoverText">K자동차 광명/화성공장 AI Virtual Fence 구축</p>
                                        <div className="hoverNextContents">
                                            <div className="inner">
                                                <p>- 중대재해를 예방하기 위해 특정 공간의 Full coverage를 감지하여 작업자 안전 사각지대를 최소화한 KT의 안전 솔루션 AI Virtual Fence</p>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td>2022년</td>
                                <td>㈜케이티</td>
                            </tr>
                            <tr>
                                <td className="textL">
                                    <div className="hoverWraps">
                                        <p className="hoverText">국가 재난안전통신망 철탑 기울기 감지장치 구축</p>
                                        <div className="hoverNextContents">
                                            <div className="inner">
                                                <p>- 고감도 IoT 센서 설치로 실시간 감시와 변이에 대한 조기 진단을 통한 안정적인 서비스 유지</p>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td>2022년 ~ 2023년</td>
                                <td>행정안전부 ※국책사업</td>
                            </tr>
                            <tr>
                                <td className="textL">
                                    <div className="hoverWraps">
                                        <p className="hoverText">5G, LTE, 3G 무선시설 전자파강도 측정 사업</p>
                                        <div className="hoverNextContents">
                                            <div className="inner">
                                                <p>- 무선설비에서 발생하는 전자파 노출량 측정을 통해 전자파 인체보호기준 준수</p>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td>2021년 ~ </td>
                                <td>㈜케이티</td>
                            </tr>
                            <tr>
                                <td className="textL">
                                    <div className="hoverWraps">
                                        <p className="hoverText">국가 재난안전통신망 운영·유지보수</p>
                                        <div className="hoverNextContents">
                                            <div className="inner">
                                                <p>- 재난 상황 발생 시 국민 건강과 안전 보호를 위해 재난안전통신망 24시간 유지/운영관리</p>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td>2019년 ~ 2025년</td>
                                <td>행정안전부 ※국책사업</td>
                            </tr>
                            <tr>
                                <td className="textL">
                                    <div className="hoverWraps">
                                        <p className="hoverText">국가 재난안전통신망 A, B사업 (1, 3단계) 구축</p>
                                        <div className="hoverNextContents">
                                            <div className="inner">
                                                <p>- 재난 발생 시 국민 건강과 안전·보호, 국가 피해 최소화 등을 목표로 한 단일 통신망 구축(수도권, 강원지역)</p>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td>2019년 ~ 2021년</td>
                                <td>행정안전부 ※국책사업</td>
                            </tr>
                            <tr>
                                <td className="textL">
                                    <div className="hoverWraps">
                                        <p className="hoverText">평창 동계올림픽 Mobile 서비스 및 Wi-Fi 운영</p>
                                        <div className="hoverNextContents">
                                            <div className="inner">
                                                <p>- 세계 최초 5G 적기구축으로 성공적인 평창동계올림픽 무선통신 서비스 제공</p>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td>2017년 ~ 2018년</td>
                                <td>㈜케이티</td>
                            </tr> */}
                        </tbody>
                    </table>
                </div>
            </main>
        </>
    );
};

export default Result;
